import { Progress } from "antd";
import PropTypes from "prop-types";
import styles from "./PlanUsageBar.module.css";

const PlanUsageBar = ({
  currentMonthRegistrations,
  planLimit,
  peakMonthRegistrations,
}) => {
  const registrationPercentage = Math.round(
    (currentMonthRegistrations / planLimit) * 100,
  );
  const isExceeded = registrationPercentage > 100;

  return (
    <div className={styles.PlanUsageContainer}>
      <div className={styles.PlanTitle}>
        Plan limit: {planLimit} registrations/month
      </div>

      <Progress
        percent={Math.min(registrationPercentage, 100)}
        strokeColor={isExceeded ? "#ff4d4f" : "#52c41a"}
        status={isExceeded ? "exception" : "active"}
        showInfo={false}
      />

      <div className={styles.PlanProgressInfo}>
        {currentMonthRegistrations} / {planLimit} registrations this month
        {peakMonthRegistrations !== null && (
          <span className={styles.PeakValue}>
            Peak month in last 12 months: {peakMonthRegistrations}
          </span>
        )}
      </div>
    </div>
  );
};

PlanUsageBar.propTypes = {
  currentMonthRegistrations: PropTypes.number.isRequired,
  planLimit: PropTypes.number.isRequired,
  peakMonthRegistrations: PropTypes.number, // optional
};

PlanUsageBar.defaultProps = {
  peakMonthRegistrations: null,
};

export default PlanUsageBar;
